<script>
/*  */
import HomeMenu from '@/components/HomeMenu';
import TabsSlider from '@/components/TabsSlider';
import Footer from '@/components/Footer';
import Button from '@/components/Button';
/*  */
import { mapState, mapActions } from 'vuex';
import { getAsset } from '@/scripts/utils';
import { scrollToBottom } from '@/scripts/utils/dom';
import { signOut } from '@/scripts/api/account';
import { clearAll } from '@/scripts/utils/store-dependent';
import { registerReferralLinkClick } from '@/scripts/api/referrals';
import { mobile } from '@/scripts/computed';

export default {
  name: 'Home',
  components: {
    Button,
    HomeMenu,
    Footer,
    TabsSlider,
  },
  data() {
    return {
      currentGame: null,
    };
  },
  computed: {
    ...mapState(['user', 'games']),
    mobile,
  },
  created() {
    this.fillDataFromUrl();

    const { games } = this;
    const [firstGame = {}] = games;
    const { id: currentGame } = firstGame;

    this.currentGame = currentGame;
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    getBackgroundImage(name) {
      const images = this.getImages(name);
      const { banner = {} } = images;
      let result = banner.url;

      if (!result) return getAsset(name, { path: 'games', type: 'png' });

      return result;
    },
    getImages(name) {
      const { games, mobile } = this;
      const game = games.find(({ id }) => id === name);
      const { images = {} } = game;
      const { home_games_we_support_icon: icon } = images;
      const bannerField = `${
        mobile ? 'mobile_' : ''
      }home_games_we_support_banner`;
      const banner = images[bannerField];

      const result = { icon, banner };

      return result;
    },
    getLogo(name) {
      const images = this.getImages(name);
      const { icon = {} } = images;

      let result = icon.url;

      return result;
    },
    signOut() {
      signOut().then(clearAll);
    },
    fillDataFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const referrerID = urlParams.get('referrer');

      if (referrerID) {
        const inStorage = localStorage.getItem('referrerID');

        if (!inStorage) registerReferralLinkClick(referrerID);

        localStorage.setItem('referrerID', referrerID);
      }
    },
    getAsset,
    scrollToBottom,
  },
};
</script>

<template>
  <div>
    <!--  -->
    <HomeMenu />

    <!--  -->
    <div class="page">
      <div class="page__content">
        <!-- hero -->
        <div
          class="hero"
          :style="
            getAsset('bg-game', { type: 'png', path: 'home', style: true })
          "
        >
          <div class="container">
            <div class="hero__content">
              <div class="hero__logo">
                <img :src="require('@/assets/svg/home/logo-big.svg')" />
              </div>
              <div class="hero__subtitle">
                Killer Rewards
              </div>
              <div class="hero__text">
                Get rewarded for every kill you make in your favorite games
              </div>
              <div class="hero__btn" v-if="!user">
                <Button to="/sign-up" class="orange default lg">
                  Sign Up
                </Button>
                <Button
                  to="/leaderboard"
                  class="icon actiive leaderboard visible-mobile"
                >
                  <img :src="require('@/assets/svg/leaderbaord-yellow.svg')" />
                  Leaderboard
                </Button>
              </div>
              <div class="hero__btn visible-mobile" v-else>
                <Button to="/dashboard" class="icon actiive dash default">
                  <img
                    :src="require('@/assets/svg/statistics.svg')"
                    class="img-icon"
                  />
                  Dashboard
                </Button>

                <Button @click="signOut" class="icon actiive logout ">
                  <img :src="require('@/assets/svg/logout.svg')" />
                  Logout
                </Button>
              </div>
            </div>

            <div class="hero__down">
              <div class="down" @click="scrollToBottom">
                <img :src="require('@/assets/svg/down-arrow.svg')" />
              </div>
            </div>
          </div>
        </div>
        <!-- // -->

        <!-- games -->
        <div class="container">
          <div class="games">
            <div class="games__left">
              <div class="title">Games We Support</div>
            </div>
            <div class="games__right">
              <div class="game-block">
                <div class="game-block__list">
                  <!--  -->
                  <TabsSlider>
                    <div
                      class="slide game-block__btn"
                      v-for="{ id } in games"
                      :key="id + 1"
                    >
                      <button
                        :class="{
                          [id]: true,
                          'btn-game': true,
                          'is-active': id === currentGame,
                        }"
                        @click="currentGame = id"
                      >
                        <img :src="getLogo(id)" class="btn-game__main" />
                      </button>
                    </div>
                  </TabsSlider>
                  <!--  -->
                </div>
                <div class="game-block__cover">
                  <img
                    :src="getBackgroundImage(currentGame)"
                    class="game-block__cover-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- // -->

        <!-- works -->
        <div
          class="works"
          :style="
            getAsset('bg-step', { type: 'png', style: true, path: 'home' })
          "
        >
          <div class="container">
            <div class="works__left">
              <div class="works__title">How Does It Work?</div>
              <div class="works__subtitle">
                Player Rush rewards you for playing the most popular games
                around. Connect your favorite game accounts, have your stats
                tracked, and earn RUSH rewards for every kill you make. It’s
                totally free and there is no limit to your rewards. Start
                earning now.
              </div>
            </div>
            <div class="works__right">
              <div class="step">
                <div class="step__wrap">
                  <div class="step__item">
                    <div class="step__line">
                      <div class="step__circle">
                        1
                      </div>
                    </div>
                    <div class="step__content">
                      <div class="step__title">Register</div>
                      <div class="step__text">
                        Easily create a Player Rush account using Discord,
                        Twitch, Google, or your Email.
                      </div>
                    </div>
                  </div>
                  <div class="step__item">
                    <div class="step__line">
                      <div class="step__circle">
                        2
                      </div>
                    </div>
                    <div class="step__content">
                      <div class="step__title">Connect</div>
                      <div class="step__text">
                        In a few simple steps, connect your favorite games to
                        your Player Rush account.
                      </div>
                    </div>
                  </div>
                  <div class="step__item">
                    <div class="step__line">
                      <div class="step__circle">
                        3
                      </div>
                    </div>
                    <div class="step__content">
                      <div class="step__title">Play</div>
                      <div class="step__text">
                        Keep playing the games you love. The more you play, the
                        more rewards you get.
                      </div>
                    </div>
                  </div>
                  <div class="step__item">
                    <div class="step__line">
                      <div class="step__circle">
                        4
                      </div>
                    </div>
                    <div class="step__content">
                      <div class="step__title">Get Rewards</div>
                      <div class="step__text">
                        Watch your rewards roll in! Rise up the leaderboard as
                        your RUSH balance grows with every kill you make.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- // -->

        <!-- tell -->
        <div
          class="tell"
          :style="
            getAsset('bg-tell', { type: 'png', style: true, path: 'home' })
          "
        >
          <div class="container">
            <div class="tell__content">
              <div class="tell__title">Tell Your Friends</div>
              <div class="tell__subtitle">
                Get rewarded every time your friend makes a kill. Sign up now
                and start sharing Player Rush rewards with your friends.
              </div>
            </div>
          </div>
        </div>
        <!-- // -->

        <!-- questions -->
        <div class="container">
          <div class="questions">
            <div class="questions__title">Any questions?</div>
            <div class="questions__list">
              <a href="mailto:support@playerrush.com" class="btn-icon"
                ><div class="btn-icon__icon">
                  <img :src="require('@/assets/svg/support.svg')" />
                </div>
                <span>Contact Support</span></a
              >
              <a
                href="//support.playerrush.com"
                class="btn-icon"
                target="_blank"
              >
                <div class="btn-icon__icon">
                  <img :src="require('@/assets/svg/audiobook.svg')" />
                </div>
                <span>Knowledge Base</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer class="footer--main" />
    </div>
    <!-- fake image prefetch -->
    <!-- TODO: -->
    <!-- <div class="fake-block">
      <img src="@/assets/png/menu/bg-about.png" />
      <img src="@/assets/png/menu/bg-referrals.png" />
    </div> -->
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.page {
  background: #0e0e0e;
}

.hero {
  position: relative;
  background-repeat: no-repeat;
  background-position-y: 25px;
  background-position-x: calc(100% + 10px);
  background-size: 1151px;
  min-height: calc(100vh - 116px);
  display: flex;

  .container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__logo {
    margin-bottom: 30px;
    display: flex;

    img {
      max-width: 465px;
      display: flex;
    }
  }

  &__subtitle {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    text-transform: uppercase;
    color: #ffc800;
    margin-bottom: 40px;
  }

  &__text {
    font-family: Sen-Regular;
    font-size: 16px;
    line-height: 1.69;
    color: #ffffff;
    margin-bottom: 25px;
    max-width: 293px;
  }

  &__btn {
    display: flex;

    &.visible-mobile {
      display: none;
    }
  }

  &__down {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 60px;
    left: 0;
  }

  &__content {
    margin-top: 20px;
    margin-bottom: 73px;
  }
}

.down {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  transition: all 0.2s;
  cursor: pointer;

  img {
    display: flex;
    width: auto;
    max-width: 100%;
  }

  &:hover {
    opacity: 0.5;
  }
}

.works {
  margin-top: 300px;
  margin-bottom: 40px;
  position: relative;
  background-repeat: no-repeat;
  background-position-y: 400px;
  padding-bottom: 228px;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__title {
    font-family: Sen-Bold;
    font-size: 60px;
    line-height: 72px;
    color: #ffc107;
    margin-bottom: 25px;
    text-transform: uppercase;
    max-width: 268px;
  }

  &__subtitle {
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 1.89;
    color: rgba(255, 255, 255, 0.8);
    max-width: 367px;
  }

  &__right {
    margin-top: 240px;
    margin-left: 30px;
  }
}

.step {
  width: 100%;
  position: relative;

  &__title {
    font-family: Sen-Bold;
    font-size: 24px;
    line-height: 29px;
    color: #ffc107;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 16px;
    line-height: 1.75;
    color: #ffffff;
  }

  &__wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0 auto;
    position: relative;
  }

  &__content {
    max-width: 370px;
    width: 100%;
  }

  &__item {
    min-height: 258px;
    display: flex;
    position: relative;

    &:last-child {
      min-height: auto;
      .step__line {
        &:before {
          display: none;
        }
      }
    }
  }

  &__line {
    font-family: Sen-Bold;
    font-size: 24px;
    line-height: 29px;
    color: #ffc107;
    margin-right: 30px;

    &:before {
      content: '';
      position: absolute;
      width: 1px;
      height: calc(100% - 108px);
      top: 88px;
      left: 34px;
      background-image: url('~@/assets/svg/home/line-dotted.svg');
    }
  }

  &__circle {
    width: 68px;
    height: 68px;
    border: solid 1px #ffc107;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
}

.fake-block {
  position: absolute;
  bottom: -10000px;
  right: -10000px;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
  user-select: none;
  z-index: -1;

  img {
    width: 0;
    height: 0;
  }
}

.games {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 165px;

  &__left {
    width: 277px;
    flex-shrink: 0;
    margin-bottom: 80px;
  }

  &__right {
    width: 100%;
    flex-grow: 1;
  }
}

.title {
  font-family: Sen-Bold;
  font-size: 60px;
  line-height: 1.2;
  text-transform: uppercase;
  color: #ffc107;
}

.game-block {
  &__list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    margin-bottom: 50px;
  }

  &__btn {
    display: flex;
    margin-left: 10px;

    & + & {
      margin-left: 40px;
    }
  }

  &__cover {
    width: 100%;
    padding-top: 25.7%;
    overflow: hidden;
    border-radius: 12px;
    position: relative;
    user-select: none;

    &:before {
      display: block;
      content: '';
      width: 100%;
    }

    &-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      object-fit: contain;
      object-position: center;
      height: 100%;
      border-radius: 12px;
      overflow: hidden;
    }
  }

  &__logo {
    position: absolute;
    top: 30px;
    left: 30px;
    display: flex;
    max-height: 50px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 30px;
    bottom: 30px;
    text-align: right;
  }

  &__title {
    font-family: Poppins-SemiBold;
    font-size: 48px;
    letter-spacing: 1px;
    line-height: 67px;
    color: #ffc800;
    margin-bottom: 10px;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 21px;
    line-height: 29px;
    letter-spacing: 0.44px;
    color: #ffc800;
  }
}

.btn-game {
  position: relative;
  width: 120px;
  height: 120px;
  border: 0;
  background: transparent;
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
  outline: none;
  cursor: pointer;

  &__main {
    object-fit: cover;
    object-position: center;
    max-width: 120px;
    max-height: 120px;
    opacity: 0.2;
    transition: all 0.2s;
    user-select: none;
  }

  &__logo {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.5;
    transition: all 0.2s;
  }

  &.fortnite {
    .btn-game__logo {
      width: 85px;
      height: 24px;
    }
  }

  &.warzone {
    .btn-game__logo {
      width: 76px;
      height: 24px;
    }
  }

  &.dota-2 {
    .btn-game__logo {
      width: 61px;
      height: 71px;
    }
  }

  &.pubg {
    .btn-game__logo {
      width: 71px;
      height: 41px;
    }
  }

  &.cs-go {
    .btn-game__logo {
      width: 85px;
      height: 35px;
    }
  }

  &:hover,
  &.is-active {
    .btn-game__logo,
    .btn-game__main {
      opacity: 1;
    }
  }
}

.tell {
  padding-top: 53px;
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: -45px;
  min-height: 825px;

  &__title {
    font-family: Sen-Bold;
    font-size: 60px;
    line-height: 1.2;
    text-transform: uppercase;
    color: #ffc107;
    max-width: 309px;
    margin-bottom: 25px;
  }

  &__subtitle {
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 1.89;
    color: rgba(255, 255, 255, 0.8);
    max-width: 367px;
  }
}

.questions {
  padding-top: 200px;
  padding-bottom: 252px;

  &__title {
    font-family: Sen-Bold;
    font-size: 48px;
    line-height: 58px;
    color: #ffce00;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 50px;
  }

  &__list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-icon + .btn-icon {
      margin-left: 30px;
    }
  }
}

.btn-icon {
  width: 100%;
  max-width: 170px;
  min-height: 130px;
  border-radius: 16px;
  border: solid 1px rgba(0, 184, 249, 0.3);
  padding: 24px 15px 15px;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  transition: all 0.2s;
  cursor: pointer;

  span {
    font-family: Poppins-Medium;
    font-size: 12px;
    line-height: 17px;
    color: #fff;
    width: 100%;
    text-align: center;
    margin-top: 24px;
  }

  &__icon {
    display: flex;
    justify-content: center;
    height: 48px;
    width: 100%;
    img {
      display: flex;
      max-height: 48px;
    }
  }

  &:hover {
    background-color: rgba(0, 184, 249, 0.1);
  }
}

.img-icon {
  width: 14px;
  height: 16px;
  display: flex;
  margin-right: 10px;
}

@media (max-width: $mobile) {
  .container {
    padding: 0 15px;
  }

  .hero {
    background-size: cover;
    background-position: center;
    min-height: 100vh;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(14, 14, 14, 0.3);
    }
    .container {
      align-items: flex-start;
      position: relative;
    }

    &__content {
      margin-top: 130px;
      margin-bottom: 100px;
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
    }

    &__down {
      bottom: 40px;
    }

    &__logo {
      height: 28px;

      img {
        height: 100%;
        width: auto;
      }
    }

    &__subtitle {
      font-size: 24px;
      line-height: 29px;
      margin-bottom: 50px;
    }

    &__text {
      text-align: center;
      line-height: 1.5;
      padding: 0 10px;
      margin-bottom: 20px;
    }

    &__btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      &.visible-mobile {
        display: flex;
      }

      .button + .button {
        margin-top: 22px;
      }
    }
  }

  .works {
    margin-top: 150px;
    background-image: none !important;
    padding-bottom: 0;

    .container {
      flex-wrap: wrap;
    }

    &__left {
      width: 100%;
    }

    &__right {
      width: 100%;
      margin-left: 0;
      margin-top: 0;
    }
  }

  .step {
    &__item {
      flex-direction: column;
      align-items: center;
      width: 100%;
      min-height: auto;
      margin-top: 100px;
    }

    &__line {
      margin-right: 0;

      &:before {
        display: none;
      }
    }

    &__content {
      margin-top: 20px;
      text-align: center;
    }

    &__title {
      margin-bottom: 30px;
    }
  }

  .questions {
    padding: 100px 0 114px;

    &__title {
      font-size: 24px;
      line-height: 29px;
    }

    &__list {
      .btn-icon + .btn-icon {
        margin-left: 20px;
      }
    }
  }

  .tell {
    padding-top: 0;
    margin-top: 150px;
    min-height: auto;
    padding-bottom: 403px;
    background-position-y: 100%;
    background-size: 135%;
    background-position-x: 12%;
  }

  .games {
    margin-top: 100px;
    flex-direction: column;
    width: 100%;

    &__left {
      width: 100%;

      .title {
        max-width: 268px;
      }
    }

    &__right {
      width: 100%;
      margin-top: 50px;
      margin-left: 0;
    }
  }

  .game-block {
    &__list {
      height: 137px;
      margin-bottom: 13px;
      margin-left: -15px;
      margin-right: -15px;
      width: calc(100% + 30px);
    }

    &__btn {
      margin: 0 10px;

      & + & {
        margin-left: 5px;
      }
    }

    &__cover {
      padding: 0;
      margin: 0 auto;
    }

    &__cover-img {
      display: flex;
      width: auto;
      max-width: 100%;
      margin: 0 auto;
      position: relative;
      left: auto;
      transform: none;
      top: auto;
      height: auto;
    }
  }
}
</style>
